import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import RequestServies from "../../../services/RequestServices";
import ItemViewModal from './ItemViewModal'

const RequsitionOrder = () => {
    const user = JSON.parse(localStorage.getItem("userDetails"));
    const availableStores = user?.data?.user?.store || [];
    const defaultStore = availableStores[0]?._id || "";

    const [selectedStore, setSelectedStore] = useState(defaultStore);
    const [open, setOpen] = useState(true);
    const [open2, setOpen2] = useState(true);
    const [sort, setSort] = useState(100); // Number of items per page
    const activePag = useRef(0);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [gridInsideModal, setGridInsideModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState();
    const [run, setRun] = useState(0)
    const [searchTerm, setSearchTerm] = useState("");
    const [allData, setAllData] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('PO Pending'); // default value



    const options = [
        { value: '5', label: '5' },
        { value: '10', label: '10' },
        { value: '20', label: '20' },
        { value: '50', label: '50' },
        { value: '100', label: '100' }
    ];

    useEffect(() => {
        if (selectedStore) {
            setLoading(true);

            let statusArray = [];
            if (selectedStatus === 'all') {
                statusArray = ['open', 'submit', 'adminSubmit', 'PO Pending', 'close']; // include all statuses
            } else {
                statusArray = [selectedStatus];
            }

            RequestServies.getRequestmutipleStatus(selectedStore, statusArray)
                .then((res) => {
                    const fetched = res?.data?.data || [];
                    setAllData(fetched);
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    console.error(error);
                });
        }
    }, [selectedStore, selectedStatus]); // ✅ now depends on both


    useEffect(() => {
        const filtered = searchTerm
            ? allData.filter(item =>
                String(item?.requisitionNo || "")
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase())
            )
            : allData;

        setData(filtered);
    }, [searchTerm, allData]);

    const handleStoreChange = (e) => {
        setSelectedStore(e.target.value);
    };

    useEffect(() => {
        if (data.length > 0) {
            activePag.current = 0; // Reset pagination when data changes
        }
    }, [data]);

    const pagination = Math.ceil(data.length / sort);
    const onClick = (i) => {
        activePag.current = i;
    };
    function formatDate(date) {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = d.getFullYear();

        return `${day}/${month}/${year}`;
    }

    //Modal
    const handleViewItems = (e, item) => {
        setSelectedItem(item); // Set the item to be edited
        setGridInsideModal(true); // Show modal
    };

    return (
        <>
            {gridInsideModal && selectedItem && (
                <ItemViewModal
                    item={selectedItem}
                    show={gridInsideModal}
                    test={setRun}
                    handleClose={() => setGridInsideModal(false)}
                />
            )}
            <div className="row">
                <div className="col-xl-12">
                    <div className="filter cm-content-box box-primary">
                        <div className={`content-title`}>
                            <div className="cpa">
                                <i className="fas fa-filter me-2"></i>Filter
                            </div>
                            <div className="tools">
                                <Link
                                    to={"#"}
                                    className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                                    onClick={() => setOpen(!open)}
                                >
                                    <i className="fas fa-angle-up"></i>
                                </Link>
                            </div>
                        </div>
                        <Collapse in={open}>
                            <div className="cm-content-body form excerpt">
                                <div className="card-body">
                                    <div className="row g-3 align-items-end">
                                        <div className="col-md-4 col-xl-4">
                                            <label className="form-label ms-2">Select Store</label>
                                            <select
                                                className="form-select pt-3 pb-3"
                                                value={selectedStore}
                                                onChange={handleStoreChange}
                                            >
                                                {availableStores.map((store) => (
                                                    <option key={store._id} value={store._id}>
                                                        {store.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-md-4 col-xl-4">
                                            <label className="form-label ms-2">Search</label>
                                            <input
                                                type="text"
                                                placeholder="Search by Requisition No"
                                                className="form-control"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                        </div>

                                        <div className="col-md-4 col-xl-4">
                                            <label className="form-label ms-2">Select Status</label>
                                            <select
                                                className="form-control"
                                                value={selectedStatus}
                                                onChange={(e) => setSelectedStatus(e.target.value)}
                                            >
                                                <option value="PO Pending">PO Pending</option>
                                                <option value="close">close</option>
                                                <option value="submit">Pending With Project Manager</option>
                                                <option value="adminSubmit">Pending With Central Team</option>
                                                <option value="all">All</option>
                                            </select>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </Collapse>
                    </div>
                    <div className="filter cm-content-box box-primary mt-1">
                        <div className={`content-title`}>
                            <div className="cpa">
                                <i className="fa fa-list me-2" aria-hidden="true"></i>Requsition Status{" "}
                                <span className="badge bg-orange ms-2">{data.length}</span>
                            </div>
                            <div className="tools">
                                <Link
                                    to="#"
                                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                    onClick={() => setOpen2(!open2)}
                                >
                                    <i className="fas fa-angle-up"></i>
                                </Link>
                            </div>
                        </div>
                        <Collapse in={open2}>
                            <div className="cm-content-body form excerpt">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div
                                            id="content_wrapper"
                                            className="dataTables_wrapper no-footer"
                                        >
                                            <div style={{
                                                overflowX: 'auto',
                                                overflowY: 'auto',
                                                maxHeight: '400px',
                                                whiteSpace: 'nowrap',
                                                position: 'relative',   // ✅ ADD THIS
                                                zIndex: 0               // ✅ ADD THIS
                                            }}>
                                                <table
                                                    className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                                                    id="active-users-data"
                                                >
                                                    <thead
                                                        style={{
                                                            position: "sticky",
                                                            top: 0,
                                                            backgroundColor: "#fff",
                                                            zIndex: 1,              // ✅ LOWER than sidebar
                                                        }}
                                                    >
                                                        <tr>
                                                            <th>S.No</th>
                                                            <th>Requisition No</th>
                                                            <th>Store</th>
                                                            <th>Requested Date</th>
                                                            <th>Status</th>
                                                            <th>Pending With</th>
                                                            <th>View Items</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {data.length > 0 ? (
                                                            data
                                                                .slice(
                                                                    activePag.current * sort,
                                                                    (activePag.current + 1) * sort
                                                                )
                                                                .map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>
                                                                            {activePag.current * sort + index + 1}
                                                                        </td>
                                                                        <td>{item?.requisitionNo}</td>
                                                                        <td>{item?.store?.name}</td>
                                                                        <td>{formatDate(item?.createdAt)}</td>
                                                                        <td>{item?.status}</td>
                                                                        <td>
                                                                            {item?.status === 'PO Pending' ? (
                                                                                'PO Team'
                                                                            ) : item?.status === 'open' ? (
                                                                                'Add Item(StoreKeeper)'
                                                                            ) : item?.status === 'submit' ? (
                                                                                'Project Manager'
                                                                            ) : item?.status === 'adminSubmit' ? (
                                                                                'Central Team'
                                                                            ) : item?.status === 'close' ? (
                                                                                'Requisition Closed'
                                                                            ) : (
                                                                                '-' // fallback for any unknown status
                                                                            )}
                                                                        </td>

                                                                        <td><i className="fa fa-eye" onClick={(e) => { handleViewItems(e, item) }}></i>
                                                                        </td>

                                                                    </tr>
                                                                ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="9" className="text-center">
                                                                    No Active items Found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info">
                                                    Showing {activePag.current * sort + 1} to{" "}
                                                    {Math.min(
                                                        data.length,
                                                        (activePag.current + 1) * sort
                                                    )}{" "}
                                                    of {data.length} entries
                                                </div>
                                                <div className="dataTables_paginate paging_simple_numbers">
                                                    <Link
                                                        className="paginate_button previous"
                                                        to="#"
                                                        onClick={() =>
                                                            activePag.current > 0 &&
                                                            onClick(activePag.current - 1)
                                                        }
                                                    >
                                                        <i
                                                            className="fa fa-angle-double-left"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </Link>
                                                    <span>
                                                        {Array.from({ length: pagination }, (_, i) => (
                                                            <Link
                                                                key={i}
                                                                to="#"
                                                                className={`paginate_button ${activePag.current === i ? "current" : ""
                                                                    }`}
                                                                onClick={() => onClick(i)}
                                                            >
                                                                {i + 1}
                                                            </Link>
                                                        ))}
                                                    </span>
                                                    <Link
                                                        className="paginate_button next"
                                                        to="#"
                                                        onClick={() =>
                                                            activePag.current < pagination - 1 &&
                                                            onClick(activePag.current + 1)
                                                        }
                                                    >
                                                        <i
                                                            className="fa fa-angle-double-right"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RequsitionOrder;
